module.exports = __webpack_public_path__ + "img/give.06af660d.svg";